import { AdminClientMetricsSimplified  } from './AdminClientMetricsSimplified';

export default AdminClientMetricsSimplified;